import React, { useRef, useState, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
// import Header from '../../components/header/header';
// import Footer from '../../components/footer/footer';
// import DashboardHeader from '../../components/organism/dashboardHeader';
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
// import theme from '../../lib/theme';
import MiniDrawer from "../../components/organism/miniDrawer";
import { getFolioList } from "../../redux/actions/init";
import { logout } from "../../redux/actions/login";
import Navbar from "./shared/navbar";
import Sidebar from "./shared/sidebar";
import Footer from "./shared/footer";
import { useSelector, useDispatch } from "react-redux";
import "../../components/pages/dashboard/dashboard.css";
import postLoginSideMenu from "../../services/postLoginMenu";
import guestZBFMenu from "../../services/guestZBFMenu";
import guestZBFMenuRed from "../../services/guestZBFMenuRed";
import "./shared/shared.css";
import queryString from "query-string";
import { PortFolioBanner } from "../../redux/actions/trans/transAction";
import {
  fetchWithWait,
  getDecryptedItem,
  matchDatewithcurrentDateToShowNFO,
  setEncryptedItem,checkExistingHUFUser
} from "../../helper/methods";
import { menuRoleWise, masterMenu } from "../../redux/actions/initApp";
import Cookie from "../../lib/cookie";
import UserApi from "../../services/userApi";
import LoginApi from "../../services/loginApi";
import Prelogin from "../../services/preLoginApi";
import ApiCall from "../trans/trans";
import { cvlData } from "../../redux/actions/trans/authAction";
import Popup from "reactjs-popup";
// import 'reactjs-popup/dist/index.css';
import "./sessionExpiryPopup.css";
import globalVariable from "../globalVariable";
import { masterMenuOptions } from "../../helper/constant";
import { useMemo } from "react";
import { removeCookie } from "../../redux/actions/removeCookies";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import CountDownTimer from "../../components/organism/counterForNFO/countDownTimer";
import { useMediaQuery } from "@material-ui/core";
import { useQueryClient } from "react-query";

let api = new UserApi();
let api2 = new LoginApi();
let api3 = new ApiCall();
let preApi = new Prelogin();
let cookie = new Cookie();

const NON_TRANSACTION_MENU = ["My Portfolio", "Orderbook", "Reports"];

const MOBILE_WEBVIEW_USER_AGENT_STRING = "NewInvestorApp";

const defaultMenuList = [];

const Wrapper = (props) => {
  let match = props.match;

  useEffect(() => {
    props.callBackForMatchedUrlParams?.({
      match,
    });
  }, [match]);

  return props.children;
};

const PrivateRoute = ({
  component: Component,
  restricted,
  hideHeader,
  ...rest
}) => {
  let dispatch = useDispatch();
  const history = useHistory();
  const isMobile = useMediaQuery("(max-width:640px)");
  const isTab = useMediaQuery("(min-width:641px) and (max-width:768px)");
  const isLaptop = useMediaQuery("(min-width:769px)");
  const [showCounterTimer, setshowCounterTimer] = useState(false);
  const queryClient = useQueryClient();
  const isFromBanner = localStorage.getItem("isFromBanner");

  useEffect(() => {
    // let ShowNFOData = matchDatewithcurrentDateToShowNFO('2024-11-21')
    let ShowNFOData = true;
    let pathFromProps = rest.path;
    let notAllowed = [
      "/prelogin-to-postlogin-connecwhattor",
      "/onboarding/:id",
      "/quickbuy",
      "/dashboard/transResp/:id",
      "/dashboard/paymentResponse",
      "/qbconfirmation",
    ];

    let isNotAllowed = notAllowed?.indexOf?.(pathFromProps) > -1;
    console.log("ShowNFOData===>", ShowNFOData);

    if (isNotAllowed) {
      setshowCounterTimer(false);
    } else {
      if (ShowNFOData) {
        setshowCounterTimer(true);
      } else {
        setshowCounterTimer(false);
      }
    }
  }, [rest.path]);

  console.log(rest, "sujeetrest");

  let path = rest.match.path;
  console.log(path, "private", rest);

  const [ClientType, setClientType] = useState("");
  const [showPopup, setshowPopup] = useState(false);
  const singleTimeRef = useRef(false);
  // const overlayRef = useRef(null);
  // let getPANNumber = useSelector(state => state.Auth.cvlData.pan || "");
  let getPANNumber = useSelector((state) => {
    try {
      if (
        state.Auth.cvlData.pan !== null &&
        state.Auth.cvlData.pan !== undefined
      ) {
        return state.Auth.cvlData.pan;
      } else {
        return "";
      }
    } catch (error) {
      return "";
    }
  });

  const [hideHeaderState, setHideHeaderState] = useState(false);
  const [hideFooterState, setHideFooterState] = useState(false);
  useEffect(() => {
    // Subscribe to the 'httpError' event
    console.log("rest.location.pathname", rest.location.pathname);
    // if (rest.location?.pathname != "/onboarding/personal") {
    const onHttpError = (status) => {
      if (status === "failed" && !singleTimeRef.current) {
        singleTimeRef.current = true;
        setshowPopup(true);
        localStorage.setItem("sessionExpired", true);
        localStorage.setItem("triggered401", true);
      }
    };

    let events = globalVariable.getPropertyByName("events");
    events.subscribe("httpError", onHttpError);
    // }

    console.log("mounting PrivateRoute");
    return () => {
      console.log("unmounting PrivateRoute");
      // Clean up the subscription when the component unmounts
      events.unsubscribe("httpError", onHttpError);
    };
  }, []);

  // const handlePopupClose = () => {
  //   setshowPopup(false);
  // }

  const popupClose = (e) => {
    let subroute =
      process.env.REACT_APP_MODE === "production" ? "/mutualfund/" : "/";
    let pathname = window.location.pathname;
    let updatedPathName =
      pathname.indexOf(subroute) === 0
        ? pathname.replace(subroute, "/")
        : pathname;
    let returnUrl =
      updatedPathName + (window.location.search ? window.location.search : "");

    let redirectPath = returnUrl ? `?returnUrl=${returnUrl}` : "";
    fetchWithWait({ dispatch, action: removeCookie() })
      .then((res) => {
        // setshowPopup(false);
        localStorage.removeItem("sessionExpired");
        localStorage.removeItem("triggered401");
        // window.location.href = '/mutualfund/login';
        history.push(`/login${redirectPath}`);
      })
      .catch((err) => {
        console.log("err in removeCookie: ", err);
        // setshowPopup(false);
        localStorage.removeItem("sessionExpired");
        localStorage.removeItem("triggered401");
        // window.location.href = '/mutualfund/login';
        history.push(`/login${redirectPath}`);
      });
  };

  // const handleOverlayClick = (e) => {
  //   e.preventDefault();
  // }

  // useEffect(() => {
  //   if(overlayRef.current) {
  //     overlayRef.current.addEventListener('click', handleOverlayClick)
  //   }

  //   return () => {
  //     if (overlayRef.current) {
  //       overlayRef.current.removeEventListener('click', handleOverlayClick)
  //     }
  //   }
  // },[])

  useEffect(() => {
    // let dd={
    //     "Popup": [{
    //         "bannerId": 68,
    //         "pageId": 99999,
    //         "imgType": "Popup",
    //         "image": "banner_14112022041949823172.jpg",
    //         "imgUrl": "https://www.motilaloswalmf.com/",
    //         "sortOrder": 1,
    //         "isactive": 1,
    //         "createdDate": "2022-11-14T04:19:49.000Z",
    //         "createdBy": "admin@admin.com",
    //         "updatedDate": null,
    //         "updatedBy": null
    //     }, {
    //         "bannerId": 63,
    //         "pageId": 99999,
    //         "imgType": "Popup",
    //         "image": "banner_09112022113946826939.jpeg",
    //         "imgUrl": "https://www.google.com/",
    //         "sortOrder": 2,
    //         "isactive": 1,
    //         "createdDate": "2022-11-09T11:39:46.000Z",
    //         "createdBy": "admin@admin.com",
    //         "updatedDate": null,
    //         "updatedBy": null
    //     }],
    //     "Dashboard": [{
    //         "bannerId": 62,
    //         "pageId": 99999,
    //         "imgType": "Dashboard",
    //         "image": "banner_09112022100848934994.jpeg",
    //         "imgUrl": "https://www.google.com/",
    //         "sortOrder": 1,
    //         "isactive": 1,
    //         "createdDate": "2022-11-09T10:08:48.000Z",
    //         "createdBy": "admin@admin.com",
    //         "updatedDate": null,
    //         "updatedBy": null
    //     }, {
    //         "bannerId": 66,
    //         "pageId": 99999,
    //         "imgType": "Dashboard",
    //         "image": "banner_14112022031329323251.jpeg",
    //         "imgUrl": "https://www.google.com/",
    //         "sortOrder": 4,
    //         "isactive": 1,
    //         "createdDate": "2022-11-14T03:13:30.000Z",
    //         "createdBy": "admin@admin.com",
    //         "updatedDate": null,
    //         "updatedBy": null
    //     }, {
    //         "bannerId": 67,
    //         "pageId": 99999,
    //         "imgType": "Dashboard",
    //         "image": "banner_14112022031451860075.jpeg",
    //         "imgUrl": "https://www.google.com/",
    //         "sortOrder": 5,
    //         "isactive": 1,
    //         "createdDate": "2022-11-14T03:14:51.000Z",
    //         "createdBy": "admin@admin.com",
    //         "updatedDate": null,
    //         "updatedBy": null
    //     }]
    // }
    // dispatch(PortFolioBanner(dd))
    let payload = {
      api_name: "getGeneralBanners",
    };
    preApi
      .getGeneralBanners(payload)
      .then((res) => {
        if (res?.data?.success) {
          console.log(res?.data?.data, "getGeneralBannersres=====");
          dispatch(PortFolioBanner(res?.data?.data));
        } else {
          dispatch(PortFolioBanner({}));
        }
        console.log(res, "getGeneralBannersres=====");
      })
      .catch((error) => {
        dispatch(PortFolioBanner({}));
      });
  }, []);

  // useEffect(() => {
  //   if (guestMenu) {
  //     if (guestNew) {
  //       setOption(guestZBFMenu)
  //     } else {
  //       setOption(guestZBFMenuRed)
  //     }
  //   } else {
  //     setOption(menuList)
  //   }
  // }, [guestMenu, guestNew])

  let menuList = useSelector(
    (state) =>
      state?.initApp?.masterMenu ||
      state?.initApp?.menuRoleWise ||
      defaultMenuList
  );
  const [option, setOption] = useState(menuList);
  const [newClient, setNewClient] = useState(false);
  const [activeAdminUser, setactiveAdminUser] = useState(false);
  const [isBurgerMenuOpen, setisBurgerMenuOpen] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  var getLocalStorage = "";
  if (typeof window !== "undefined") {
    getLocalStorage = getDecryptedItem("uniqueKey");
    getLocalStorage = getLocalStorage;
  }

  let userDetails = {
    apiName: "clientType",
    body: { panNo: getPANNumber || getLocalStorage?.panNo },
  };

  const logoutClick = () => {
    queryClient.removeQueries({ queryKey: "foliodet" });
    dispatch(logout());
  };

  let getItem = localStorage.getItem("pageUrl");
  if (getItem == "unclaimed") {
    dispatch(logout());
  }

  let guestMenu = useSelector((state) => state.Auth.guestMenu);
  console.log("guestMenu", guestMenu);

  let guestNew = useSelector((state) => state.Auth.guestNew);
  console.log("guestNew", guestNew);

  useEffect(() => {
    if (guestMenu) {
      if (guestNew) {
        setOption(guestZBFMenu);
      } else {
        setOption(guestZBFMenuRed);
      }
    } else {
      setOption(menuList);
    }
  }, [guestMenu, guestNew]);

  useEffect(() => {
    setInitials();
    checkClient();
    decrptCookie();
    let clientTypeArr = localStorage.getItem("ClientType");
    if (clientTypeArr) {
      let clientJsonData = JSON.parse(clientTypeArr);
      setClientType(clientJsonData.data.existingClient);
    }
  }, []);

  const setInitials = async () => {
    let clientTypeArr = localStorage.getItem("ClientType");
    let panNoArr = getDecryptedItem("uniqueKey");

    if (!panNoArr || !clientTypeArr) {
      // Call PAN from Token.
      // Call CVL API.
      // Call ClientType API.
      // Set localstorage.
      let CustPAN = "";
      let getPayload = {
        apiName: "GetPanFromToken",
        params: "",
      };
      let apiResponsePAN = await api3.commonGet(getPayload);
      console.log("apiResponsePAN =========", apiResponsePAN);
      if (apiResponsePAN.data?.success === true) {
        CustPAN = apiResponsePAN.data.data;
        let CVLpayload = {
          apiName: "kycCheck",
          body: { panNo: CustPAN },
        };
        let kycResponse = await api2.common(CVLpayload);

        let payloadClientType = {
          apiName: "clientType",
          body: { panNo: CustPAN },
        };
        let clientTypeResponse = await api2.common(payloadClientType);

        localStorage.setItem(
          "ClientType",
          JSON.stringify(clientTypeResponse.data)
        );
        setEncryptedItem("uniqueKey", {
          panNo: CustPAN,
          nameAsOnPan: kycResponse.data?.data?.nameAsOnPan,
        });

        clientTypeArr = localStorage.getItem("ClientType");
        if (clientTypeArr) {
          let clientJsonData = JSON.parse(clientTypeArr);
          setClientType(clientJsonData.data.existingClient);
        }
      }
    }
  };

  const checkClient = async () => {
    let res = await api2.common(userDetails);
    console.log("Isnewclient", res);
    if (res?.data && res?.data?.data && res?.data?.data?.newClient) {
      if (
        res?.data?.data?.newClient == "BOTH" ||
        res?.data?.data?.newClient == "MF" ||
        res?.data?.data?.existingClient == "ZBF"
      ) {
        setNewClient(true);
      } else {
        setNewClient(false);
      }
    } else {
      setNewClient(false);
    }
    console.log("newClient", newClient);
  };

  const decrptCookie = async () => {
    let paylaod = {};
    let authedicateUser = await api.authedicate();

    if (authedicateUser?.data?.success) {
      setactiveAdminUser(true);
      setIsAdmin(true);
      localStorage.setItem("userRole", JSON.stringify(authedicateUser?.data));
      if (cookie.getCookie("userRollID")) {
        console.log("userRollId", cookie.getCookie("userRollID"));
        let payload = { data: cookie.getCookie("userRollID") };
        let rollID = await api.getParams(payload);
        console.log("rollID", rollID.data.data);
        paylaod = { roleId: rollID.data.data };
        // paylaod = { roleId: "1" }
      } else {
        paylaod = { roleId: "0" };
      }

      fetchWithWait({ dispatch, action: menuRoleWise(paylaod) }) // role wise menu - not hard coded. taking from api
        .then((res) => {
          console.log(`res normal usermenu`, res);
          setOption(res);
        })
        .catch((e) => {
          console.log(`error`, e);
        });
    } else {
      localStorage.setItem("userRole", JSON.stringify(authedicateUser?.data));
      setIsAdmin(false);
      //condition added for zbf user
      if (guestMenu) {
        if (guestNew) {
          setOption(guestZBFMenu); //zero balance folio - hard coded list
        } else {
          setOption(guestZBFMenuRed); //redeemed zero balance folio - hard coded list
        }
        //setOption(guestZBFMenu);
      } else {
        console.log("masterMenuOptions", masterMenuOptions);
        setOption(masterMenuOptions); //master menu list - hard coded list
        // fetchWithWait({ dispatch, action: masterMenu() })
        //   .then((res) => {
        //     console.log(`res master usermenu 1`, res);
        //     setOption(res);
        //   })
        //   .catch((e) => {
        //     console.log(`error`, e);
        //   });
      }
    }
  };

  useEffect(() => {
    let fabPathName = rest.location.pathname;
    if (fabPathName === "/fab-plan/confirmation") {
      document.body.classList.toggle("sidebar-icon-only");
      if (!document.body.classList.contains("sidebar-icon-only")) {
        document.body.classList.toggle("sidebar-icon-only");
      }
    }
  }, [rest.location]);

  const handleOnClickBurgerMenu = (isShow) => {
    // alert(isShow)
    console.log("isShow", isShow);
    if (document.body.classList.contains("sidebar-icon-only")) {
      setisBurgerMenuOpen(isShow ? isShow : false);
    } else {
      setisBurgerMenuOpen(isShow ? isShow : true);
    }
  };

  const callBackForMatchedUrlParams = ({ match }) => {
    console.log("callBackForMatchedUrlParams match", match);
    let isWindow = typeof window !== "undefined";
    if (isWindow) {
      let isComingFromMobileWebview =
        window?.navigator?.userAgent === MOBILE_WEBVIEW_USER_AGENT_STRING;
      if (isComingFromMobileWebview) {
        if (
          (match?.path === "/manage-account/:id" &&
            match?.params?.id === "nomineemanage") ||
          match?.path === "/schedule-investments/sip" ||
          match?.path === "/schedule-investments/stp" ||
          match?.path === "/schedule-investments/swp"
        ) {
          setHideHeaderState(true);
          setHideFooterState(true);
        } else {
          setHideHeaderState(false);
          setHideFooterState(false);
        }
      } else {
        setHideHeaderState(false);
        setHideFooterState(false);
      }
    } else {
      setHideHeaderState(false);
      setHideFooterState(false);
    }
  };

  // useEffect(() => {
  //   window.addEventListener("beforeunload", alertUser);
  //   window.addEventListener("unload", handleTabClosing);
  //   return () => {
  //     window.removeEventListener("beforeunload", alertUser);
  //     window.removeEventListener("unload", handleTabClosing);
  //   };
  // });

  // const handleTabClosing = () => {
  //   console.log("HISUJEETTAB");
  //   alert("");
  // };

  // const alertUser = (event) => {
  //   alert("");
  //   console.log(event, "event===");
  //   event.preventDefault();
  //   dispatch(logout());

  //   event.returnValue = "";
  // };
  // console.log(props,'privateRouter')
  const isFabConfirmation = rest?.location?.pathname?.includes(
    "/fab-plan/confirmation"
  );
  // hide menu for non-individual pan no
  const userInfo = getDecryptedItem("userInfo");
  let updateOptions = useMemo(() => {
    return JSON.parse(JSON.stringify(option));
  }, [option]);

  console.log('isMenu', !isAdmin, !userInfo?.isIndividualPan)
    const existingHUFUser = checkExistingHUFUser();
    console.log("existingHUFUser",existingHUFUser)
      if (!existingHUFUser && !isAdmin && !userInfo?.isIndividualPan) {
        updateOptions = Object.keys(option).length === 0 ? [] : option?.filter(function (currentItem) {
          return NON_TRANSACTION_MENU.includes(currentItem?.menu?.label)
        });
  }
 
  let heightForStrip = 0;
  if (showCounterTimer) {
    if (isMobile) {
      heightForStrip = "18vh";
    }
    if (isTab) {
      heightForStrip = "10vh";
    }
    if (isLaptop) {
      heightForStrip = "10vh";
    }
  }

  return (
    // restricted = false meaning public route
    // restricted = true meaning restricted route
    <React.Fragment>
      {/*  */}
      <div className="container-scroller">
        <Navbar
          logout={logoutClick}
          activeAdminUser={activeAdminUser}
          burgermenu={handleOnClickBurgerMenu}
          isFabConf={isFabConfirmation}
          isAdmin={isAdmin}
          showCounterTimer={showCounterTimer}
          heightForStrip={heightForStrip}
        />

        {showPopup ? (
          <>
            <Popup
              open={showPopup}
              onClose={popupClose}
              className="sessionExpiredPP"
              modal
            >
              {/* <div ref={overlayRef} className="popup-overlay" onClick={handleOverlayClick}> */}
              {/* Popup content */}
              <div className="popup-contents">
                <h2 className="primary-blue-text">Session Expired</h2>
                <p>Your session has been expired!! Kindly login again.</p>
                <button className="primary-blue-button" onClick={popupClose}>
                  Login
                </button>
              </div>
              {/* </div> */}
            </Popup>
          </>
        ) : (
          <div
            className={`container-fluid page-body-wrapper ${hideHeaderState
              ? ""
              : ClientType.indexOf(",") !== -1 && !activeAdminUser
                ? "mainBodyPT100"
                : "mainBodyPT65"
              } ${showCounterTimer ? "showNFOStrip" : ""}`}
          >
            {rest.hideSidebar || isFabConfirmation || isFromBanner ? null : (
              <>
                {updateOptions.length >= 1 ? (
                  <Sidebar
                    option={updateOptions}
                    newClient={newClient}
                    burgerMenu={isBurgerMenuOpen}
                    handleburgermenu={handleOnClickBurgerMenu}
                  />
                ) : null}
              </>
            )}
            <div
              className={`${isFabConfirmation ? "" : "main-panel"} ${rest.hideSidebar ? `fullWidth` : ``
                }`}
              style={{}}
            >
              <div
                className={`${rest.path === "/fab-plan/:id" ? "" : "content-wrapper"
                  }`}
              >
                <Route
                  {...rest}
                  render={(props) => (
                    <Wrapper
                      match={props.match}
                      callBackForMatchedUrlParams={callBackForMatchedUrlParams}
                    >
                      <Component {...props} />
                    </Wrapper>
                  )}
                />
              </div>
              <Footer />
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};
export default withRouter(PrivateRoute);
